<template>
	<div class="personage">

		<el-form ref="form" :model="form" label-width="150px" :rules="rules" class="form">

			<h2 style="margin: 20px 0;font-size: 16px;font-weight: 500; color: #409eff;border-bottom: solid #DCDFE6 1px;padding-bottom: 10px;">注册的码标归属区域</h2>
			<el-form-item label="码标注册区域：" prop="site">
				<span v-if="form.territory!=''">{{form.territory}}</span>

				<div class="size f-cb" v-else>
					<el-select v-model="form.site.province.value" placeholder="请选择省份" style="float: left;width:30%" @visible-change="province" @change="provinceVal">
						<el-option v-for="item in form.site.province.data" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
					<el-select v-model="form.site.city.value" placeholder="请选择市" style="float: left;width: 28%; margin-left: 10px;" @change="city" no-data-text="请先选择上一级">
						<el-option v-for="item in form.site.city.data" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
					<el-select v-model="form.site.district.value" placeholder="请选择区" style="float: left;width:28%; margin-left: 10px;" no-data-text="暂无数据">
						<el-option v-for="item in form.site.district.data" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</div>

			</el-form-item>

			<h2 style="margin-top: 20px;font-size: 16px;font-weight: 500; color: #409eff;margin-bottom: -20px; border-bottom: solid #DCDFE6 1px;padding-bottom: 10px;">个人资料填写</h2>
			<p class="error-me-tlt">个人资料支持修改部分信息，请务必填写真实信息，方便我们能及时联系到您！</p>

			<div v-if="!IdcodeUserId">
				<el-form-item label="登录名称：" prop="userName">
					<el-input v-model.trim="form.userName" type="text" style="width:40%"></el-input>
				</el-form-item>
				<el-form-item label="密码：" prop="userPassword">
					<el-input v-model.trim="form.userPassword" type="password" style="width:40%"></el-input>
				</el-form-item>
				<el-form-item label="确认密码：" prop="userPasswordTwo">
					<el-input v-model.trim="form.userPasswordTwo" type="password" style="width:40%"></el-input>
				</el-form-item>
			</div>
			<!--<el-form-item label="test："  prop="userD.name">
			<el-input v-model.trim="form.userD.name" type="text" style="width:80%"></el-input>
		</el-form-item>-->
			<!--{{form.userD.name}}-->
			<!--<u-user-gather :userData="form.userD" :verifys="['name']" :verifysRules="rules.userD"> </u-user-gather>-->
			<el-form-item label="姓名：" prop="name.value">
				<el-input v-model="form.name.value" style="width: 40%;" placeholder="请填写姓名" :disabled="form.name.disabled"></el-input>
			</el-form-item>
			<!--<el-form-item label="联系电话：" prop="phone">
				<el-input v-model.trim="form.phone" placeholder="请填写联系电话" style="width: 70%;"></el-input>
			</el-form-item>-->

			<el-form-item label="身份证号：" prop="identity">
				<el-input v-model="form.identity.value" placeholder="请填写身份证号" style="width: 70%;" :disabled="form.identity.disabled"></el-input>
			</el-form-item>

			<el-form-item label="身份证正面图片：" prop="identityPhotograph.entity.imageBig">
				<file-upload ref="upload2" v-model="files2" input-id="files2" :disabled="uploading" style="vertical-align: middle;" :post-action="$api+'/upload/uploadImageFile'" @input-file="frontOfIDcard" @input-filter="inputFilterImg" :size="1024 * 1024*5" @input="updatetValue('upload2')">
					<el-button type="primary" plain :disabled="uploading">上传图片</el-button>

				</file-upload>
				<div class="el-upload__tip" style="display: inline-block;margin-left: 20px;">您的身份证正面照片</div>
				<!--{{form.frontOfIDcardImg}}-->
				<div v-if="form.identityPhotograph">
					<div class="upload-data-strip f-cb" v-show="/\.(jpeg|jpe|jpg|gif|png|webp|bmp)$/i.test(form.identityPhotograph.entity.imageBig)" @click="amplificationImg(form.identityPhotograph.entity.imageBig)">
						<i class="el-icon-tickets"></i>
						<span>
							
                        	{{form.identityPhotograph?(form.identityPhotograph.entity.name||form.identityPhotograph.entity.imageBig):''}}
                        	</span>
						<span class="f-fr" style="cursor: pointer;">
                        	查看
                            </span>
					</div>
				</div>
				<!--<div class="el-upload__tip">企业负责人的身份证正面照片</div>-->

			</el-form-item>
			<el-form-item label="身份证国徽面图片：" prop="NationalEmblem.entity.imageBig">
				<!--<el-button type="primary" plain>上传图片</el-button>-->
				<file-upload ref="upload3" v-model="files3" input-id="files3" :disabled="uploading" style="vertical-align: middle;" :post-action="$api+'/upload/uploadImageFile'" @input-file="NationalEmblemImg" @input-filter="inputFilterImg" :size="1024 * 1024*5" @input="updatetValue('upload3')">
					<el-button type="primary" plain :disabled="uploading">上传图片</el-button>

				</file-upload>
				<div class="el-upload__tip" style="display: inline-block;margin-left: 20px;">您的身份证国徽照片</div>
				<div v-if="form.NationalEmblem">
					<div class="upload-data-strip f-cb" v-show="/\.(jpeg|jpe|jpg|gif|png|webp|bmp)$/i.test(form.NationalEmblem.entity.imageBig)" @click="amplificationImg(form.NationalEmblem.entity.imageBig)">
						<i class="el-icon-tickets"></i>
						<span>
							<!--{{form.NationalEmblem ? '哈哈' : form.NationalEmblem.entity}}-->
							<!--{{form.NationalEmblem.entity.imageBig}}-->
                        	{{form.NationalEmblem ? (form.NationalEmblem.entity.name||form.NationalEmblem.entity.imageBig) : ''}}
                        	</span>
						<span class="f-fr" style="cursor: pointer;">
                        	查看
                            </span>
					</div>
				</div>
			</el-form-item>

			<el-form-item>
				<!--<div style="text-align: center;">-->
				<el-button type="primary" @click="onSubmit('form')">保存</el-button>
				<!--<el-button>取消</el-button>-->
				<!--</div>-->

			</el-form-item>
		</el-form>
	</div>
</template>

<script>
	export default {

		data() {
			var sitePass = (rule, value, callback) => {

				if(this.form.territory != '') {
					callback();
				} else {
					if(value.province.value === '') {
						callback(new Error('请输入地址'));

					} else {

						if(this.form.resource == 'province' && value.province.value == "") {
							//          this.$refs.ruleForm.validateField('sitef');
							callback(new Error('请输入省份'));
						} else if(this.form.resource == 'city' && value.province.value == "" && value.city.value == "") {
							callback(new Error('请输入省份和市'));

						}

						callback();
					}
				}

			};
			var doubleDeck = (rule, value, callback) => {
				let val = value.value
				if(val) {
					callback()
				} else {
					callback(new Error('请输入内容'));
				}
			}
			var identityVerify = (rule, value, callback) => {
				let val = value.value
				if(val) {

					if(/^(^[1-9]\d{7}((02[0-2]\d)|((01|03|05|07|08|10|12)(([0-2]\d)|3[0-1]))|((04|06|09|11)(([0-2]\d)|30)))\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((02[0-2]\d)|((01|03|05|07|08|10|12)(([0-2]\d)|3[0-1]))|((04|06|09|11)(([0-2]\d)|30)))((\d{4})|\d{3}[Xx])$)$|(^((\s?[A-Za-z])|([A-Za-z]{2}))\d{6}(([0−9aA])|([0-9aA]))$)|(^[1|5|7][0-9]{6}[0-9A-Z]$)|(^[A-KM-QT-XZ]{1}[0-9]{9}$)/.test(val)) {
						this.$http.get(this.$api + '/organUnit/validateOrganizationCode', {
							params: {
								organizationCode: val,
								organUnitID: (this.IdcodeUserId ? this.IdcodeUserId : 0)
							}
						}).then(res => {
							//					console.log(res)
							if(res.body.result === 1) {
								callback();

							} else {
								callback(new Error(res.body.message));

							}

						})
					} else {
						callback(new Error('身份证号码格式不正确，请重新填写'));

					}

				} else {
					callback(new Error('请输入身份证号'));
				}

			};
			var validatePass = (rule, value, callback) => {
				if(value === '') {
					callback(new Error('请输入密码'));
				} else {

					if(this.form.userPasswordTwo === '') {
						this.$refs.form.validateField('userPasswordTwo');
					}
					callback();
				}
			};
			var validatePass2 = (rule, value, callback) => {
				if(value === '') {
					callback(new Error('请再次输入密码'));
				} else if(value !== this.form.userPassword) {
					callback(new Error('两次输入密码不一致，请重新输入!'));
				} else {
					callback();
				}
			};

			var registerNamePass = (rule, value, callback) => {
				this.$http.get(this.$api + '/organUnit/validateLoginName', {
					params: {
						loginName: value
					}
				}).then(res => {
					if(res.body.result === 0) {
						callback(new Error(res.body.message));

					} else {
						callback();

					}
				})
			}
			return {
				files2: [],
				files3: [],
				uploading: false,
				form: {
					userD: {
						name: '111',
						Password: '',
						PasswordTwo: '',
					},

					name: {
						value: '',
						disabled: false,
					},
					territory: '',
					site: {
						province: {
							value: '',
							data: '',
						},
						city: {
							value: '',
							data: '',
						},
						district: {
							value: '',
							data: '',
						},
					},

					identity: {
						value: '',
						disabled: false,
					},
					identityPhotograph: {
						entity: {
							imageBig: ''
						}
					},
					NationalEmblem: {
						entity: {
							imageBig: ''
						}
					},
					userName: '',
					userPassword: '',
					userPasswordTwo: '',
					phone: '',
				},
				inquires: {
					parentID: 0,
					level: 1
				},
				rules: {
					userD: {
						name: {
							required: true,
							message: 'hahaha',
							trigger: 'blur'
						}

					},
					name: {
						value: [{
							required: true,
							message: '请输入姓名',
							trigger: 'blur'
						}]

					},
					site: [{
						required: true,
						validator: sitePass,
						trigger: 'blur'
					}],
					identity: [{
						required: true,

						validator: identityVerify,
						trigger: 'blur'
					}],
					phone: [{
							pattern: /^((13|14|15|17|18|19)[0-9]{1}\d{8})$/,
							message: '电话号格式不正确，请检查',
							trigger: 'blur'
						},
						{
							required: true,
							message: '请填写联系电话',
							trigger: 'blur'
						}
					],

					userPassword: [{
							required: true,
							validator: validatePass,
							trigger: 'blur'
						},
						{
							pattern: /^[A-Za-z0-9_]+$/,
							message: '请输入6至20位的英文字母、数字或两者组合！',
							trigger: 'blur'
						},
						{
							min: 6,
							max: 20,
							message: '请输入6至20位的密码',
							trigger: 'blur'
						}
					],
					userPasswordTwo: {
						required: true,
						validator: validatePass2,
						trigger: 'blur'
					},

					userName: [{
						required: true,
						message: '登录名称',

						trigger: 'blur'

					}, {
						validator: registerNamePass,
						trigger: 'change'
					}],
					NationalEmblem: {
						entity: {
							imageBig: [{
									required: true,
									message: '请上传您的身份证国徽面照片',
									trigger: 'blur'
								},

							]
						}
					},
					identityPhotograph: {
						entity: {
							imageBig: [{
									required: true,
									message: '请上您的身份证正面照片',
									trigger: 'blur'
								},

							]
						}
					},
					img: {
						entity: {
							imageBig: [{
									required: true,
									message: '请上传图片',
									trigger: 'blur'
								},

							]
						}

					}
				}
			}
		},
		computed: {
			IdcodeUserId() {
				return this.$store.state.commonalityData.IdcodeUserId
			}
		},
		created() {
			//			this.province();
			if(this.IdcodeUserId) {
				this.FromData();
			}
			//			this.FromData();

		},
		methods: {
			FromData() {
				this.$http.get(this.$api + '/organUnit/getUnitInfoByID', {
					params: {
						unitID: this.$store.state.commonalityData.IdcodeUserId
					}
				}).then(res => {
					console.log(res.body)
					if(res.body.result === 1) {
						let {
							form,
							uploading
						} = this;
						let {
							personName,
							personArea,
							personIDNumber,
							personIDCard,
							//							personPhone,
							messageTip
						} = res.body.entity;
						//						console.log(personPhone)
						personName.disabled = parseInt(personName.isDisabled) === 1 ? true : false;
						form.name = personName; //名称
						//						form.phone = personPhone.value; //电话
						form.territory = personArea; //地址
						personIDNumber.disabled = parseInt(personIDNumber.isDisabled) === 1 ? true : false;
						console.log(personIDNumber.isDisabled)
						form.identity = personIDNumber //身份证号
						//                   //身份证照片
						//						personIDCard.disabled =
						form.identityPhotograph.entity.imageBig = personIDCard.value.split('|')[0];
						form.NationalEmblem.entity.imageBig = personIDCard.value.split('|')[1];
						uploading = parseInt(personIDCard.isDisabled) === 1 ? true : false;
						//                            展示栏
						this.$emit('post', messageTip === null ? '' : messageTip)
						//						console.log(personIDCard.value.split('|')[0])

					}

				})
			},
			onSubmit(formName) {
				this.$refs[formName].validate((valid) => {
					if(valid) {
						//						alert('submit!');
						let {
							IdcodeUserId
						} = this.$store.state.commonalityData, {
							form
						} = this;

						this.$http.post(this.$api + '/organUnit/savePersonInfo', {
							organunit_id: IdcodeUserId ? IdcodeUserId : 0,
							organunitname: form.name.value,
							province_id: form.site.province.value,
							city_id: form.site.city.value,
							area_id: form.site.district.value,
							organizationcode: form.identity.value,
							linkphone: form.phone,
							organunitlicense: form.identityPhotograph.entity.imageBig + '|' + form.NationalEmblem.entity.imageBig,
							loginName: form.userName,
							loginPwd: form.userPassword

						}).then(res => {
							if(res.body.result === 1) {
								this.$message({
									message: '提交修改成功',
									type: 'success',
									duration: '900',

								});
								this.$store.dispatch('DataUpdate', res.body.entity).then(res => {
									this.$setCookie('Data', escape(JSON.stringify(res)));

								})
								setTimeout(() => {
									this.$router.push('/')
								}, 1000)

								//								this.$store.state.commonalityData.IdcodeUserId = res.body.entity.organunit_id;
								//								this.$store.state.commonalityData.name = res.body.entity.organunitname;
								//								var yang = JSON.stringify(res.body.entity);
								//								this.$setCookie('Data', escape(yang));
							} else {
								this.$message.error(res.body.message + '请尝试重新提交');
							}

						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			updatetValue(value) {
				this.$refs[value].active = true;

			},
			frontOfIDcard(newFile, oldFile) {
				if(newFile && oldFile && !newFile.active && oldFile.active) {

					if(newFile.xhr) {
						let res = JSON.parse(newFile.xhr.response)
						if(res.result == 1) {
							if(res.entity != undefined) {
								this.form.identityPhotograph = res;
							}
						} else {
							this.$message({
								showClose: true,
								message: res.message,
								duration: '1000',
								type: 'error'
							});
						}
					} else if(newFile.iframe) {
						if(newFile.response.entity) {
							let res = newFile.response

							if(res.result == 1) {
								this.form.identityPhotograph = res;
								console.log(res)

							} else {
								this.$message({
									showClose: true,
									message: res.message,
									duration: '1000',
									type: 'error'
								});
							}
						}
					}
				}
			},
			NationalEmblemImg(newFile, oldFile) {
				if(newFile && oldFile && !newFile.active && oldFile.active) {

					if(newFile.xhr) {
						let res = JSON.parse(newFile.xhr.response)
						if(res.result == 1) {
							if(res.entity != undefined) {
								this.form.NationalEmblem = res;
							}
						} else {
							this.$message({
								showClose: true,
								message: res.message,
								duration: '1000',
								type: 'error'
							});
						}
					} else if(newFile.iframe) {
						if(newFile.response.entity) {
							let res = newFile.response

							if(res.result == 1) {
								this.form.NationalEmblem = res;
								console.log(res)

							} else {
								this.$message({
									showClose: true,
									message: res.message,
									duration: '1000',
									type: 'error'
								});
							}
						}
					}
				}
			},
			inputFilterImg(newFile, oldFile, prevent) {
				if(newFile && !oldFile) {
					// 过滤不是图片后缀的文件
					if(!/\.(jpeg|jpe|jpg|gif|png|webp|bmp)$/i.test(newFile.name)) {
						this.$message.error('仅支持jpg.png.gif.jpeg.bmp后缀图片上传');

						return prevent()
					}
					if(newFile.size > 1024 * 1024 * 5) {
						this.$message.error('请上传5MB以内的文件');

					}

				}

				// 创建 blob 字段 用于图片预览
				newFile.blob = ''
				let URL = window.URL || window.webkitURL
				if(URL && URL.createObjectURL) {
					newFile.blob = URL.createObjectURL(newFile.file)
				}
			},
			locationdata() {
				let a = this.$http.get(this.$api + '/baseData/getAddressList', {
					params: this.inquires
				});
				return a;
			},

			//省
			province() {
				let province = this.form.site.province.data;
				if(province) {
					return;
				} else {
					this.locationdata().then(function(res) {
						if(res.data != "") {
							this.form.site.province.data = res.body.entity.map(function(item) {
								return {
									value: item.address_id,
									label: item.addressname
								}

							})
						}

					})
				}
			},
			provinceVal(value) {
				this.inquires.parentID = value;
				this.inquires.level = 2;
				this.locationdata().then(function(res) {
					this.form.site.city.data = res.body.entity.map(function(item) {
						return {
							value: item.address_id,
							label: item.addressname
						}
					})

					this.form.site.city.value = this.form.site.city.data[0].value;
					this.city(this.form.site.city.data[0].value);
				});

			},
			city(value) {

				this.inquires.parentID = value;
				this.inquires.level = 3;

				this.locationdata().then(function(res) {
					this.form.site.district.data = res.body.entity.map(function(item) {
						return {
							value: item.address_id,
							label: item.addressname
						}
					})
					this.form.site.district.value = this.form.site.district.data[0].value

				})
			},
			amplificationImg(url) {
				//			console.log(url)
				this.$alert('<img src=' + '/UploadImages/' + url + '></img>', {
					showConfirmButton: false,
					dangerouslyUseHTMLString: true,
					customClass: 'imgalert',
					callback: (done) => {
						//						done();
					}
				});
			},

		}

	}
</script>

<style lang="scss" scoped>
	.personage {
		text-align: left;
		.form {
			width: 80%;
		}
	}
	
	.upload-data-strip {
		color: #606266;
		display: block;
		margin-right: 40px;
		overflow: hidden;
		width: 400px;
		/*padding:  4px;*/
		/*line-height: 10px;*/
		text-overflow: ellipsis;
		transition: color .3s;
		cursor: pointer;
		white-space: nowrap;
		/*background-color: rgb(217, 236, 255);*/
		border-radius: 5px;
		&:hover {
			color: #1B59A8;
			/*rgb(179, 216, 255)*/
			/*background-color: rgb(236, 245, 255);*/
			/*border-bottom: solid  rgb(236, 245, 255) 1px;*/
		}
	}
</style>